<div class="card hover-show w-100 overflow-auto h-100 d-flex flex-column">
    <div class="position-absolute start-0" style="top: 2.5rem">
        <app-label [label]="linkedContract.entity.connection.info.marketSegment"
                   [translateContent]="false"></app-label>
    </div>
    <div class="card-body flex-grow-1 d-flex flex-column overflow-hidden">
        <div class="text-center mb-3">
            <h2 class="card-title notranslate">
                <app-connection-image [connectionType]="linkedContract.entity.connection.info.connectionType"></app-connection-image>
                {{ linkedContract.entity.connection.info.code }}
            </h2>
            <h5 class="text-muted notranslate">{{ linkedContract.entity.location.info?.name }}</h5>
            <span *ngIf="linkedContract.entity.connection.info.label" class="text-muted notranslate text-truncate">
                <i class="bi bi-tag"></i>
                {{ linkedContract.entity.connection.info.label }}
            </span>
        </div>
        <hr class="card-divider m-0 mb-3">
        <div class="list-group-flush list-group overflow-y-auto overflow-x-hidden flex-grow-1" style="max-height: 200px;">
            <div *ngFor="let linkedContract of linkedContract.linkedContracts;"
                 class="list-group-item py-3">
                <div class="row">
                    <div class="col-auto">
                        <i class="bi me-1 bi-calendar"></i>
                    </div>
                    <div class="col text-truncate notranslate text-muted">
                        <small>
                            <app-contract-range [dateRange]="linkedContract.dateRange" [isReadOnly]="true"></app-contract-range>
                        </small>
                    </div>
                    <div class="col-auto my-3 ms-2" *ngIf="appContext.isAdminOrIntermediary()">
                        <button type="button" class="btn position-absolute top-0 end-0 to-show" style="right: 24px !important;"
                                (click)="openLinkContractToConnectionModal(linkedContract)">
                            <i class="bi bi-pencil"></i>
                        </button>
                    </div>
                    <div class="col-auto my-3">
                        <app-confirmation-toggle *ngIf="appContext.isAdminOrIntermediary()">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h3 class="modal-title">Remove contract</h3>
                                    <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button>
                                </div>
                                <div class="modal-body">
                                    <p>Are you sure you want to remove this contract from this connection?</p>
                                </div>
                                <div class="modal-footer justify-content-between">
                                    <a type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</a>
                                    <button type="button" class="btn btn-primary"
                                                (click)="unlinkContractFromConnection(linkedContract)"
                                            data-bs-dismiss="modal">
                                        Remove contract
                                    </button>
                                </div>
                            </div>
                            <button type="button" class="btn position-absolute top-0 end-0 to-show"
                                    role="button" aria-expanded="false">
                                <i class="bi bi-trash"></i>
                            </button>
                        </app-confirmation-toggle>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="appContext.isAdminOrIntermediary()" class="list-group-item py-3 pointer hover-underline mt-auto"
             (click)="linkContractToConnection()">
            <div class="row">
                <div class="col-auto">
                    <i class="bi me-2 bi-plus-circle"></i>
                </div>
                <div class="col text-truncate">
                    <small>Add period</small>
                </div>
            </div>
        </div>
    </div>
</div>